import { Stack } from '@mui/material'
import { LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'

export function ValuationTenantListPageLoading() {
    return (
        <Stack direction="column" paddingTop={tokens.SizingSpacing100} gap={tokens.SizingSpacing400}>
            <PageGridContainer>
                <PageGridItem columnSpan={6} columnSpanXs={4}>
                    <LoadingSkeleton variant="rounded" height="120px" />
                </PageGridItem>
            </PageGridContainer>

            <LoadingSkeleton variant="rounded" height="400px" />
        </Stack>
    )
}
